import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getEmployeePayrollApproversDb } from "../Layouts/HRMS/Payroll/PayrollApprovers/Services";
import { loggedInUserInfoSliceActions } from "../Store/Slices/LoggedInUserInfo";

// Extend only this user's routes; never mutate the shared role configuration.
export const getUserRoutes = (config, role, isPayrollApprover) => {
  const roleRoutes = config[role] || [];

  if (!isPayrollApprover || roleRoutes.some((route) => route.path === "Payroll")) {
    return roleRoutes;
  }

  const payrollRoute = config.hradmin?.find((route) => route.path === "Payroll");
  if (!payrollRoute) return roleRoutes;

  return [
    ...roleRoutes,
    {
      ...payrollRoute,
      module: [...new Set(roleRoutes.flatMap((route) => route.module || []))],
      children: payrollRoute.children.filter(
        (route) => route.path === "" || route.path === "EmployeePayrollApproval",
      ),
    },
  ];
};

export const usePayrollApproverRoutes = (routesConfig) => {
  const dispatch = useDispatch();
  const { userInfo, accessToken, isPayrollApprover } = useSelector(
    (state) => state.loggedInUserInfo,
  );
  const userUid = userInfo?.uid;
  const employeeUid = userInfo?.employeeProfile?.uid;
  const [checkedIdentity, setCheckedIdentity] = useState(null);
  const identity = JSON.stringify([userUid, employeeUid, accessToken]);

  useEffect(() => {
    let isCurrent = true;

    dispatch(loggedInUserInfoSliceActions.setIsPayrollApprover(false));

    const checkApprover = async () => {
      try {
        if (accessToken && userUid && employeeUid) {
          const response = await getEmployeePayrollApproversDb({
            query: {
              approver_uid: employeeUid,
              is_active: true,
              is_deleted: false,
              $limit: 0,
            },
          });

          if (isCurrent) {
            dispatch(
              loggedInUserInfoSliceActions.setIsPayrollApprover(
                response?.data?.total > 0,
              ),
            );
          }
        }
      } finally {
        if (isCurrent) setCheckedIdentity(identity);
      }
    };

    checkApprover().catch((error) =>
      console.error("Payroll approver lookup failed", error),
    );

    return () => {
      isCurrent = false;
    };
  }, [dispatch, accessToken, userUid, employeeUid, identity]);

  return {
    routes: getUserRoutes(
      routesConfig,
      userInfo?.rolesInfo?.title?.toLowerCase(),
      isPayrollApprover,
    ),
    loading: checkedIdentity !== identity,
  };
};
